import React from "react";
import {Else, If, Then} from "react-if";
import useToggle from '@react-hook/toggle';
import Register from "./components/register/Register";
import Login from 'gui/pages/mainRouter/pages/ad/components/commons/adRegisterOrLogin/components/login/Login';

export interface IAdStructure {
  signedIn: boolean;
  clickedPurchase: boolean;
}

const AdRegisterOrLogin = (props: IAdStructure) => {
  const [isLogin, toggleLogin] = useToggle(false, true, false);
  return (<If condition={!props.signedIn && props.clickedPurchase}>
    <Then>
      {() =>
        <If condition={!isLogin}>
          <Then>
            <Register toggleLogin={toggleLogin}/>
          </Then>
          <Else>
            <Login toggleLogin={toggleLogin}/>
          </Else>
        </If>
      }
    </Then>
  </If>)
};

AdRegisterOrLogin.defaultProps = {
  clickedPurchase: false,
  signedIn: false,
};

export default AdRegisterOrLogin;
